/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".push-to-wallet-header[_ngcontent-%COMP%]{text-align:center}.push-to-wallet-header[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#4ea046;font-size:40px;font-weight:800;line-height:40px;margin-top:10px}.push-to-wallet-header[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#9ce29c;font-size:40px;font-weight:400;line-height:40px}"];
export { styles as styles };
